import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/match_certification_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered). The API
// resource declares no attributes, only the two to-one relationships;
// inverse:null because neither side declares a reciprocal.
const MatchCertificationSchema = withDefaults({
  type: 'match-certification',
  fields: [
    {
      kind: 'belongsTo',
      name: 'matchPayment',
      type: 'match-payment',
      options: { async: false, inverse: null },
    },
    {
      kind: 'belongsTo',
      name: 'matchPeriod',
      type: 'match-period',
      options: { async: false, inverse: null },
    },
  ],
});

export default MatchCertificationSchema;
